import { useState } from "react";
import { useAppDispatch } from "src/hooks/redux";
import { updateAttention, updateCSAssignation, updateRecommendation, updateTypification } from "src/redux/prospects/prospects.thunks";
import { Prospect } from "src/redux/prospects/prospects.types";

export const useHandleProspectCS = (prospect: Prospect) => {
    const dispatch = useAppDispatch();
    const [loadingSelection, setLoadingSelection] = useState<boolean>(false)


    const onChangeAssignedUser = (assigned_id) => {
        setLoadingSelection(true);
        dispatch(updateCSAssignation({ prospect_id: prospect.id, assigned_id })).unwrap().then(() => {
            setLoadingSelection(false);
        });
    }

    const onChangeAttention = (attention_id) => {
        setLoadingSelection(true);
        dispatch(updateAttention({ prospect_id: prospect.id, attention_id })).unwrap().then(() => {
            setLoadingSelection(false);
        });
    };

    const onChangeRecommendation = (recommendation_id) => {
        setLoadingSelection(true);
        dispatch(updateRecommendation({ prospect_id: prospect.id, recommendation_id })).unwrap().then(() => {
            setLoadingSelection(false);
        });
    }

    const onChangeTypification = (typification_id) => {
        setLoadingSelection(true);
        dispatch(updateTypification({ prospect_id: prospect.id, typification_id })).unwrap().then(() => {
            setLoadingSelection(false);
        });
    }

    return { onChangeAssignedUser, onChangeAttention, onChangeRecommendation, onChangeTypification, loadingSelection };
}